/**
 * Hashes a string using the djb2 algorithm for better uniqueness between strings.
 * @param {string} str - The input string to hash.
 * @returns {string} - The resulting hash as a hexadecimal string.
 */
export const hashString = (str: string): string => {
  let hash = 5381
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) + hash + str.charCodeAt(i) // hash * 33 + c
    hash = hash & 0xffffffff // Ensure 32-bit integer
  }
  // Convert to unsigned and return as hex string for better uniqueness
  return (hash >>> 0).toString(16)
}
